import React, { Component } from 'react'
import {uploadDqcData,updateDqcData,inputDqcData,exportDrawing} from './../actions/wizard';
import { connect } from "react-redux";
import { ReactComponent as Close} from './../assets/icons/close.svg';
class InputModal extends Component<any,any> {
    constructor(props) {
      super(props)
      this.state = {
         name:this.props.customerDetails?.DQC_Manager?.name || "",
         emailId:this.props.customerDetails?.DQC_Manager?.emailId || ""
      }
    }
    onPostingData = () => {
        if(this.props.dqcUpdateMode){
            this.props.updateDqcData(this.state);
        }
        else{
        this.props.uploadDqcData(this.state);
        }
  }

  onCloseModal = () =>{
      this.props.inputDqcData({isDqcDataPresent:true,dqcUpdateMode:false,dqcAddMode:false});
  }

  onSkipAndContinue = () => {
     this.props.inputDqcData({isDqcDataPresent:true,dqcUpdateMode:false,dqcAddMode:false});
     this.props.exportDrawing(this.props.projectDetails);
  }
  render() {
    const {DQC_Manager} = this.props.customerDetails;
    const {emailId,name} = DQC_Manager;
    return (
        <div id="id01" className="input-modal">
        <div className="popupInner">
            <div className="inputpopupHead">
                <p>Enter DQC Name And Email</p>
                <Close onClick={this.onCloseModal}></Close>
            </div>
            <div className="inputpopupContent">
                <div>
                <label>Name: </label>
                <input placeholder='Enter Name' defaultValue={name || ""} className={'dqcNameInput'} onChange={(e) => this.setState({'name':e.target.value})}/>
                 </div>
                <div>
                <label>Email :  </label>
                <input placeholder='Enter Email' defaultValue={emailId || ""} className={'dqcEmailInput'} onChange={(e) => this.setState({'emailId':e.target.value})}/>
                </div>

            </div>
            <div className="popupFooter" style={{justifyContent: "flex-end"}}>
                <div className="close-btn" onClick={this.onPostingData}>Save And Continue</div>
                { this.props.dqcAddMode && <div className="close-btn" onClick={this.onSkipAndContinue}>Skip And Continue</div>}
            </div>
        </div>
    </div>
)

  }
}

export default connect(
    (state: any) => ({
    dqcUpdateMode:state.wizard.dqcUpdateMode,
    dqcAddMode:state.wizard.dqcAddMode,
    projectDetails: state.wizard.projectDetails,
    customerDetails: state.wizard.customer_details
    }),
    {
       uploadDqcData,
       updateDqcData,
       inputDqcData,
       exportDrawing
    }
)(InputModal);